import React from "react";
import styled from "styled-components";
import Flex from "./Flex";

interface SDotStatus {
  color?: string;
  size?: string;
  isBold?: boolean;
}

interface DotStatusProps extends SDotStatus {
  text: string;
}

export default function DotStatus({
  text,
  color,
  size,
  isBold,
}: DotStatusProps) {
  return (
    <Flex gapSize={8}>
      <>
        <Dot color={color} />

        <Text color={color} size={size} isBold={isBold}>
          {text}
        </Text>
      </>
    </Flex>
  );
}

const Dot = styled.div<SDotStatus>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ color }) => color ?? "#f42d16"};
`;

const Text = styled.span<SDotStatus>`
  font-size: ${({ size }) => (size === "sm" ? 15 : 18)}px;
  line-height: ${({ size }) => (size === "sm" ? 22.5 : 24)}px;
  font-weight: ${({ isBold }) => (isBold ? "bold" : "500")};
  text-align: left;
  color: ${({ color }) => color ?? "#f42d16"};
  word-break: keep-all;
`;
